 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML00A_HALFTI from '@/components/html/00a_halfti'
 import HTML01_TITLE_PA from '@/components/html/01_Title_Pa'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML03_FRONT_MA from '@/components/html/03_Front_Ma'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_ACKNOWLE from '@/components/html/05_Acknowle'
 import HTML06_1_INTROD from '@/components/html/06_1_Introd'
 import HTML07_2_THE_LI from '@/components/html/07_2_The_Li'
 import HTML08_3__THE_C from '@/components/html/08_3__The_C'
 import HTML09_4__RITES from '@/components/html/09_4__Rites'
 import HTML10_5__THE_D from '@/components/html/10_5__The_D'
 import HTML11_6__THE_K from '@/components/html/11_6__The_K'
 import HTML12_7__SIGNI from '@/components/html/12_7__Signi'
 import HTML13_8__MARVE from '@/components/html/13_8__Marve'
 import HTML14_9__EPILO from '@/components/html/14_9__Epilo'
 import HTML15_NOTES from '@/components/html/15_Notes'
 import HTML16_BIBLIOGR from '@/components/html/16_Bibliogr'
 import HTML17_INDEX from '@/components/html/17_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Acknowle",
 			"name" : "html/05_Acknowle",
 			"component" : HTML05_ACKNOWLE
 		},
 		{
 			"path" : "/html/06_1_Introd",
 			"name" : "html/06_1_Introd",
 			"component" : HTML06_1_INTROD
 		},
 		{
 			"path" : "/html/07_2_The_Li",
 			"name" : "html/07_2_The_Li",
 			"component" : HTML07_2_THE_LI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js